import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  ReloadIcon,
  lucidWarningIcon,
} from '@g99-product-web-ui/shared-util-lib';

export type ErrorStateType = 'warning' | 'info' | 'error' | 'success';

@Component({
  selector: 'lib-error-state',
  templateUrl: './error-state.component.html',
  styleUrl: './error-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ErrorStateComponent {
  @Input() public type: ErrorStateType = 'warning';
  @Input() public icon = lucidWarningIcon;
  @Input() public title = 'Something went wrong';
  @Input() public subtext =
    'There was an error while fetching data. Please try again later or reload the page.';
  @Input() public showButton = true;
  @Input() public buttonLabel = 'Reload Page';
  @Input() public buttonIcon = ReloadIcon;

  @Input() public hasAdditionalContent = false;
  @Output() public buttonClick = new EventEmitter<void>();

  public onButtonClick() {
    this.buttonClick.emit();
  }
}
